(function () {
	'use strict';

	angular.module('app.dashboard')
	.config(projectedShortagesConfig);

	function projectedShortagesConfig(dashboardProvider) {
		// register widget
		dashboardProvider
			.widget('projectedShortages',
				{
					name: 'Projected Shortages',
					description: 'The total number of items projected to become a shortage inside the item-level supplier lead time.',
					thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/projectedshortagesthumb.png',
					categories: ['All', 'Shortages'],
					config: {},
					slideshowView: true,
					isActive: true,
					controller: 'projectedShortagesChartCtrl',
					templateUrl: '/application/f/dashboard/widgets/projected-shortages/projected-shortages-chart.html',
					defaultDrillDownUrl: '/application/f/home.html#/supply-chain/material-shortages/shortages-by-item/?drilldown=1',
					reload: true,
					isDrillDown: true,
					isEditable: true,
					reactDrilldownUrl: '/application/f/home.html#/supply-chain/material-shortages/shortages-by-item',
					isNewDrillDown: true
				}
			);
	}
})();
